const personalPage = [
    {
        path: "/realInfo",
        name: "实名信息",
        component: () => import("@views/personalCenter/realInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/accountInfo",
        name: "账户信息",
        component: () => import("@views/personalCenter/accountInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/accountLogout",
        name: "账户注销",
        component: () => import("@views/personalCenter/accountLogout.vue"),
        meta: {
            title: "账户注销",
            singleHead: true
        },
    },
    {
        path: "/contactMes",
        name: "联系信息",
        component: () => import("@views/personalCenter/contactInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/contactAdd",
        name: "联系地址",
        component: () => import("@views/personalCenter/modifyAddress.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/modifyEmail",
        name: "我的邮箱",
        component: () => import("@views/personalCenter/myEmail.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/addPriTradeVoucherMail",
        name: "交易凭证抄送邮箱",
        component: () => import("@views/personalCenter/addPriTradeVoucherMail.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/editEmail",
        name: "修改邮箱",
        component: () => import("@views/personalCenter/modifyEmail.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            singleHead: true
        },
    },
    {
        path: "/checkEmailCode",
        name: "验证邮箱",
        component: () => import("@views/personalCenter/checkEmailCode.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/wealthAdvisor",
        name: "关联推荐人",
        component: () => import("@views/personalCenter/wealthAdvisor.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/modifyIncome",
        name: "年收入",
        component: () => import("@views/personalCenter/modifyIncome.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/modifyRecord",
        name: "是否有不良诚信记录",
        component: () => import("@views/personalCenter/modifyRecord.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/myPhone",
        name: "我的手机号",
        component: () => import("@views/personalCenter/myPhone.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/modifyPhoneNumber",
        name: "修改手机号",
        component: () => import("@views/personalCenter/modifyPhoneNumber.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/uploadPhoneMaterial",
        name: "修改手机号",
        component: () => import("@views/personalCenter/uploadPhoneMaterial.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/modifyNaturalPerson",
        name: "是否特定自然人",
        component: () => import("@views/personalCenter/modifyNaturalPerson.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/modifyOccupation",
        name: "职业",
        component: () => import("@views/personalCenter/modifyOccupation.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/upLoadCertValidDateNoIdcard",
        name: "证件有效期",
        component: () => import("@views/personalCenter/upLoadCertValidDateNoIdcard.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/help",
        name: "帮助中心",
        component: () => import("@views/personalCenter/help.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/contactUs",
        name: "联系我们",
        component: () => import("@views/personalCenter/contactUs.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/bankSearchPage",
        name: "支持自动扣款的银行",
        component: () => import("@views/personalCenter/bankSearchPage.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/branchBankPage",
        name: "分支行",
        component: () => import("@views/personalCenter/branchBankPage.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/addBank",
        name: "银行卡",
        component: () => import("@views/personalCenter/addBank.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            questionIcon: true
        },
    },
    {
        path: "/bankCardList",
        name: "银行卡列表",
        component: () => import("@views/personalCenter/bankCardList.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            questionIcon: true
        },
    },
    {
        path: "/bindCard",
        name: "绑定银行卡",
        component: () => import("@views/personalCenter/bindCard.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            showPhoneIcon: true
        },
    },
    //个人非身份证
    {
        path: "/bindNotIdCard",
        name: "绑定银行卡",
        component: () => import("@views/personalCenter/bindNotIdCard.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            showPhoneIcon: true
        },
    },
    {
        path: "/bankCardDetail",
        name: "银行卡详情",
        component: () => import("@views/personalCenter/bankCardDetail.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/bankCardEdit",//银行卡修改
        name: "银行卡详情",
        component: () => import("@views/personalCenter/bankCardEdit.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            singleHead: true
        },
    },
    {
        path: "/bankDetail",
        name: "银行卡详情",
        component: () => import("@views/personalCenter/bankDetail.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/bankCommonProblem",
        name: "银行卡常见问题",
        component: () => import("@views/personalCenter/bankCommonProblem.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/orgBasicInfo",
        name: "机构基本信息",
        component: () => import("@views/personalCenter/orgBasicInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/orgBasicInfoEdit",//机构基本信息修改
        name: "机构基本信息",
        component: () => import("@views/personalCenter/orgBasicInfoEdit.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            singleHead: true,
            // keepAlive:true,
        },
    },
    {
        path: "/orgOcrCertificateInfo",
        name: "修改证件有效期",
        component: () => import("@views/personalCenter/orgOcrCertificateInfo.vue"),
        meta: {
            title: "机构修改证件有效期ocr确认",
            showBg: false,
            singleHead: true,
        },
    },
    {
        path: "/updateOrgEmail",//机构邮箱修改
        name: "办公邮箱",
        component: () => import("@/views/orgAccount/orgPersonalCenter/updateOrgEmail.vue"),
        meta: {
            title: "办公邮箱",
            showBg: false,
            // singleHead: true,
        },
    },
    {
        path: "/confirmSetPublicCard",
        name: "个人公募卡修改",
        component: () => import("@/views/personalCenter/confirmSetPublicCard.vue"),
        meta: {
            title: "银行卡",
            showBg: false,
            singleHead: true,
        },
    },
    {
        path: "/bankCheck",
        name: "银行证明",
        component: () => import("@/views/personalAccount/bankCheck.vue"),
        meta: {
            title: "银行证明",
            showBg: false,
        },
    },
    {
        path: "/orgAccountInfo",
        name: "账户信息",
        component: () => import("@views/personalCenter/orgAccountInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/orgAgentInfo",
        name: "授权经办人信息",
        component: () => import("@views/personalCenter/orgAgentInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/orgShareholderInfo",
        name: "机构控股股东信息",
        component: () => import("@views/personalCenter/orgShareholderInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/orgTaxDeclaration",
        name: "机构税收声明",
        component: () => import("@views/personalCenter/orgTaxDeclaration.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/orgContactInfo",
        name: "机构联系信息",
        component: () => import("@views/personalCenter/orgContactInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/orgBeneficiary",
        name: "机构受益人信息",
        component: () => import("@views/personalCenter/orgBeneficiary.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/designatedAssets",
        name: "指定资产",
        component: () => import("@views/personalCenter/designatedAssets.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/assetCertificate",
        name: "申请资产证明",
        component: () => import("@views/personalCenter/assetCertificate.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/ocrCertificateInfo",
        name: "修改证件有效期",
        component: () => import("@views/personalCenter/ocrCertificateInfo.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },

]
export default personalPage